
import React from 'react';
import ProtectedRoute from '@/components/auth/ProtectedRoute';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Button } from '@/components/ui/button';

const SentryTest = () => {
  const handleBreakClick = () => {
    throw new Error("This is your first error!");
  };

  return (
    <ProtectedRoute requiredRole="admin">
      <Navbar />
      <div className="container mx-auto px-4 py-24 min-h-screen flex flex-col items-center justify-center">
        <h1 className="text-3xl font-bold mb-8">Sentry Test Page</h1>
        <p className="mb-8 text-muted-foreground">
          This page is only visible to administrators. Click the button below to trigger a Sentry error.
        </p>
        <Button 
          variant="destructive" 
          onClick={handleBreakClick}
          className="text-lg py-6 px-8"
        >
          Break the world
        </Button>
      </div>
      <Footer />
    </ProtectedRoute>
  );
};

export default SentryTest;
